/**
 * Mirrors @neuraville/react-core-pro auth/authViolation (kept local so the app
 * layout does not import the full react-core-pro bundle — that dist pulls
 * browser-only code at module load and breaks Next SSR/prerender).
 */

export const REGION_UNSUPPORTED_STATUS = 451;
export const REGION_UNSUPPORTED_MESSAGE =
  "Your country of origin is not supported.";

function parseNumericStatus(value) {
  if (typeof value === "number" && Number.isFinite(value)) {
    return value;
  }
  if (typeof value === "string") {
    const parsed = Number.parseInt(value, 10);
    if (Number.isFinite(parsed)) {
      return parsed;
    }
  }
  return undefined;
}

function extractStatus(error) {
  if (!error || typeof error !== "object") {
    return undefined;
  }

  const direct =
    parseNumericStatus(error.status) ??
    parseNumericStatus(error.status_code) ??
    parseNumericStatus(error.body?.status_code);
  if (direct !== undefined) {
    return direct;
  }

  const text = typeof error.message === "string" ? error.message : "";
  const match = text.match(/\b([45]\d{2})\b/);
  if (!match) {
    return undefined;
  }
  return parseNumericStatus(match[1]);
}

function extractMessage(error) {
  if (!error || typeof error !== "object") {
    return undefined;
  }

  const body = error.body;
  const detail = body?.detail;
  if (typeof detail === "string" && detail.trim()) {
    return detail.trim();
  }
  if (detail && typeof detail === "object") {
    if (typeof detail.message === "string" && detail.message.trim()) {
      return detail.message.trim();
    }
  }

  if (typeof error.message === "string" && error.message.trim()) {
    return error.message.trim();
  }

  return undefined;
}

export function resolveAuthViolation(error, fallbackMessage) {
  const status = extractStatus(error);
  const isRegionUnsupported = status === REGION_UNSUPPORTED_STATUS;
  const message = isRegionUnsupported
    ? REGION_UNSUPPORTED_MESSAGE
    : extractMessage(error) ?? fallbackMessage;

  return {
    status,
    message,
    isRegionUnsupported,
  };
}
